<div class="application-page" [nbSpinner]="!ready" nbSpinnerMessage="Loading your crew...">
  <ngx-invite-search *ngIf="ready" [event]="event" [crew]="crew" [unassignedWorkspaceMembers]="unassignedWorkspaceMembers"></ngx-invite-search>
  <ngx-invite-list
    *ngIf="ready"
    [eventId]="event.id"
    [assignedMembers]="assignedMembers"
    [assignedWorkspaceMembers]="assignedWorkspaceMembers"
    [unassignedWorkspaceMembers]="unassignedWorkspaceMembers"
    class="d-flex flex-grow-1"
  ></ngx-invite-list>
  <ngx-marketplace *ngIf="ready"></ngx-marketplace>
</div>
